import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import scrollToAnimated from 'web-ui-kit/animations/scrollToAnimated';
import NavButton from 'web-ui-kit/buttons/NavButton';
import ProductCard, { ProductCardReferrer } from 'web-ui-kit/cards/ProductCard';
import { MQ_FOR_TABLET_LANDSCAPE_UP, MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT } from 'web-ui-kit/media';
import { Header4SmallStyles, Header4LargeStyles } from 'web-ui-kit/typography';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var SWAP_CONFIG = {
  visible: false
}; // The scrolling animation duration for Nav button clicks.

var SCROLL_ANIMATION_DURATION_MS = 700;
/**
 * Horizontally scrolling list of product cards.
 */

function Swimlane(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? '' : _ref$heading,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$parentProduct = _ref.parentProduct,
      parentProduct = _ref$parentProduct === void 0 ? {} : _ref$parentProduct,
      _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop; // We  will manage scroll and nav button state internally.

  var hscrollRef = useRef();

  var _useState = useState({
    back: 'hidden',
    forward: 'hidden'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      navButtonState = _useState2[0],
      setNavButtonState = _useState2[1];

  useEffect(function () {
    var el = hscrollRef.current;

    if (el && el.scrollWidth > el.clientWidth) {
      setNavButtonState({
        back: 'hidden',
        forward: 'visible'
      });
    }
  }, []);

  var handleScroll = function handleScroll(jsEvent) {
    var el = jsEvent.target;

    if (el) {
      if (el.scrollLeft === 0) {
        setNavButtonState({
          back: 'hidden',
          forward: 'visible'
        });
      } else if (el.scrollLeft + el.clientWidth === el.scrollWidth) {
        setNavButtonState({
          back: 'visible',
          forward: 'hidden'
        });
      } else {
        setNavButtonState({
          back: 'visible',
          forward: 'visible'
        });
      }
    }
  };

  var handleNavBackClick = function handleNavBackClick() {
    var el = hscrollRef.current;
    var scrollOffset = 80;
    var to = Math.max(el.scrollLeft - el.clientWidth + scrollOffset, 0);
    scrollToAnimated(el, to, SCROLL_ANIMATION_DURATION_MS);
  };

  var handleNavForwardClick = function handleNavForwardClick() {
    var el = hscrollRef.current;
    var scrollOffset = 80;
    var to = Math.min(el.scrollLeft + el.clientWidth - scrollOffset, el.scrollWidth - el.clientWidth);
    scrollToAnimated(el, to, SCROLL_ANIMATION_DURATION_MS);
  }; // Handle product card events.


  var handleDispatch = function handleDispatch(_ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;
    var isCardClick = type === 'product-card-clicked'; // Append the parent productId to the payload

    payload.parentProductId = get(parentProduct, 'id');
    dispatch({
      type: isCardClick ? "pd-".concat(id, "-").concat(type) : type,
      payload: payload
    });

    if (isCardClick) {
      scrollToTop();
    }
  };

  var BackNav = styles.BackNav,
      Container = styles.Container,
      ForwardNav = styles.ForwardNav,
      Heading = styles.Heading,
      HScrollContainer = styles.HScrollContainer,
      HScroll = styles.HScroll;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "".concat(id, "-swimlane")
    },
    /*#__PURE__*/
    React.createElement(Heading, null, heading),
    /*#__PURE__*/
    React.createElement(HScrollContainer, null, navButtonState.back === 'visible' &&
    /*#__PURE__*/
    React.createElement(BackNav, {
      onClick: handleNavBackClick,
      variant: 'back'
    }),
    /*#__PURE__*/
    React.createElement(HScroll, {
      ref: hscrollRef,
      onScroll: handleScroll,
      id: "hscroll"
    }, products.map(function (product, index) {
      return (
        /*#__PURE__*/
        React.createElement(ProductCard, _extends({
          key: product.id,
          buttonConfig: SWAP_CONFIG,
          dispatch: handleDispatch,
          image: product.heroImg,
          imgixProps: {
            loading: 'lazy'
          },
          cardPosition: index,
          tag: product.badge,
          likeStatus: product.liked,
          product: product,
          referrer: ProductCardReferrer.PDP_ALT
        }, product))
      );
    })), navButtonState.forward === 'visible' &&
    /*#__PURE__*/
    React.createElement(ForwardNav, {
      onClick: handleNavForwardClick,
      variant: 'forward'
    })))
  );
}
/**
 * Styles
 */


var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1.5rem 1rem;\n\n    ", " {\n      padding: 1.5rem 0 1rem 0;\n    }\n\n    /** This is needed to ensure the modal vertical scroll bar\n     *  stays on top of the full bleed product card grid.\n     */\n    z-index: 0;\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Heading: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.5rem;\n\n    ", " {\n      ", ";\n      margin-bottom: 1rem;\n    }\n  "])), Header4SmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, Header4LargeStyles),
  HScrollContainer: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: relative;\n  "]))),
  HScroll: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-auto-columns: calc(50% - 2rem);\n    grid-auto-flow: column;\n    grid-gap: 0.5rem;\n    grid-template-columns: 0.5rem;\n\n    /** Full bleed container */\n    margin: 0 -1rem;\n\n    /** Make container scroll horizontally */\n    max-width: 100vw;\n    overflow-x: auto;\n    overflow-y: hidden;\n\n    /** Empty placeholders reqd for full bleed effect. */\n    &:before,\n    &:after {\n      content: '';\n      width: 0.5rem;\n    }\n\n    ", " {\n      grid-auto-columns: calc(33% - 2rem);\n    }\n\n    ", " {\n      grid-auto-columns: calc(25% - 2rem);\n      grid-gap: 0.75rem;\n      grid-template-columns: 1.75rem;\n      margin: 0 -2.5rem;\n      max-width: calc(100% + 5rem);\n\n      &:before,\n      &:after {\n        content: '';\n        width: 1.75rem;\n      }\n    }\n  "])), MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT, MQ_FOR_TABLET_LANDSCAPE_UP),
  BackNav: styled(NavButton)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    left: -0.5rem;\n    transform: translateY(-50%);\n    z-index: 1;\n\n    ", " {\n      left: -1.75rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  ForwardNav: styled(NavButton)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    right: -0.5rem;\n    transform: translateY(-50%);\n    z-index: 1;\n\n    ", " {\n      right: -1.75rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP)
};
export default Swimlane;